/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Copilot_Threshold_DescriptionInputs */



/**
* | output |
* | --- |
* | "Determine how certain the model must be before escalating." |
*
* @param {Compliance_Copilot_Threshold_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_copilot_threshold_description = /** @type {((inputs?: Compliance_Copilot_Threshold_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Copilot_Threshold_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bestimmen Sie, wie sicher das Modell sein muss, bevor es eskaliert.")
	return /** @type {LocalizedString} */ ("Determine how certain the model must be before escalating.")
});